import { Clonable } from '../../../common';

export class DiscoverySource extends Clonable {
  constructor(
    public readonly id: string,
    public readonly name: Record<string, string>,
  ) {
    super();
  }
}
